import React from "react";
import { Link } from "react-router-dom";

function ContactWrapperArea() {
  return (
    <>
      <div className="contact-wrapper pt-110">
        <div className="container">
          <div className="row align-items-center justify-content-lg-center gy-5">
            <div className="col-lg-6">
              <div className="contatc-intro-figure">
                <img
                  src={process.env.PUBLIC_URL + "/images/banner/contact-bg.png"}
                  alt="ContactBannerIMG"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-lg-5">
              <div className="contact-info">
                <h3>Get in touch</h3>
                <ul>
                  <li>
                    <h6>Questions about courses, facilities, travel, the cosmos... ask us anything.</h6>
                    <i className="fa-solid fa-envelope"></i> <a href="mailto:hi@campfr.com">hi@campfr.com</a>
                  </li>
                  <li>
                    <h6>Connect with CAMP</h6>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.facebook.com/campfr"
                    >
                      <i className="fa-brands fa-facebook fa-xl"></i>
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://instagram.com/camp_fr"
                    >
                      <i className="fa-brands fa-instagram fa-xl"></i>
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://whatsapp.com/channel/0029VbAijiPJpe8WT0t0Ij2j"
                    >
                      <i className="fa-brands fa-whatsapp fa-xl"></i>
                    </a>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://bsky.app/profile/campfr.bsky.social"
                    >
                      <i className="fa-brands fa-bluesky fa-xl"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactWrapperArea;
